import Card from "react-bootstrap/Card";
import { useLang } from "../../context/LanguageContext";
import { translations } from "../../translations";

function AboutCard() {
  const { lang } = useLang();
  const tr = translations[lang].aboutCard;

  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            {tr.bio}
            <br />
            <br />
            {tr.extra}
          </p>
          {/* <ul>
            {tr.hobbies.map((hobby, i) => (
              <li key={i} className="about-activity">
                <ImPointRight /> {hobby}
              </li>
            ))}
          </ul> */}
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
